module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-right-normal-big.76410311.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-right-normal-big.png
// module id = 2650
// module chunks = 11